import React, { useEffect, useState } from "react";
import firebase from "./firebase";

export const AuthContext = React.createContext();
export const TokenContext = React.createContext();

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(
    localStorage.getItem("userData")
      ? JSON.parse(localStorage.getItem("userData"))
      : []
  );
  const [userToken, setUserToken] = useState(
    localStorage.getItem("userToken")
      ? JSON.parse(localStorage.getItem("userToken"))
      : []
  );

  useEffect(() => {
    const unsubscribe = firebase.auth().onAuthStateChanged(async (user) => {
      const token = user ? await user.getIdTokenResult() : null;
      setCurrentUser(user);
      setUserToken(token);
      localStorage.setItem("userData", JSON.stringify(user));
      localStorage.setItem("userToken", JSON.stringify(token));
    });
    return () => unsubscribe();
  }, []);

  return (
    <AuthContext.Provider
      value={{
        currentUser,
      }}
    >
      <TokenContext.Provider value={{ userToken }}>
        {children}
      </TokenContext.Provider>
    </AuthContext.Provider>
  );
};
